import { addGtagData, setTrackedTripDetailDepart, setTrackedTripDetailReturn } from '@/slices/gtag/slices/gtagSlice';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { useGetGtagData, useTrackPassengerPage } from '@/utils/hooks/use-gtag';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

interface GTagWrapperProps {
  page: 'trip-detail' | 'passenger' | 'add-baggage' | 'pay';
}

const GTagWrapper: React.FC<GTagWrapperProps> = ({ page }) => {
  const dispatch = useAppDispatch();
  const gtagData = useGetGtagData();
  const { isTrackedTripDetailDepart, isTrackedTripDetailReturn } = useAppSelector((state) => state.gtagSlice);
  const { handleTrack: handlePassengerTracking } = useTrackPassengerPage();
  const { query } = useRouter();
  const isReturn = query?.type === 'return';
  useEffect(() => {
    if (!gtagData || !gtagData?.value) return;
    if (page === 'trip-detail') {
      if (isReturn && isTrackedTripDetailReturn) return;
      if (!isReturn && isTrackedTripDetailDepart) return;
      dispatch(addGtagData(gtagData));
      if (isReturn) {
        dispatch(setTrackedTripDetailReturn({ value: true }));
      }
      dispatch(setTrackedTripDetailDepart({ value: true }));
    }
    if (page === 'passenger') {
      handlePassengerTracking();
    }
  }, []);
  return <></>;
};
export default GTagWrapper;
